module.exports = __webpack_public_path__ + "img/galerie-31.50ac6466.jpg";